import { HealthDataHeaderCard } from './health-data-header-card';
import { HealthDataEditorTitleDesktop } from './health-data-editor-title-desktop';
import { HealthDataNavigation } from './health-data-navigation';

interface HealthDataEditorCardProps {
  categories: string[];
  activeCategory?: string;
  onCategoryClick: (category: string) => void;
  isLoading?: boolean;
}

export function HealthDataEditorCard({
  categories,
  activeCategory,
  onCategoryClick,
  isLoading = false,
}: HealthDataEditorCardProps) {
  return (
    <HealthDataHeaderCard
      variant="editor"
      titleContent={
          <>
            <HealthDataEditorTitleDesktop />
            {(categories.length > 0 || isLoading) && (
              <div className="mt-6">
                <HealthDataNavigation
                  categories={categories}
                  activeCategory={activeCategory}
                  onCategoryClick={onCategoryClick}
                  isLoading={isLoading}
                />
              </div>
            )}
          </>
        }
    />
  );
}
